<template>
	<span>
		<Button
			icon="checkmark"
			:text="inContacting ? 'In Kontaktierung' : 'Anonym kontaktieren'"
			:primary="!inContacting"
			:success="inContacting"
			:disabled="inContacting"
			@click="onClick"
		/>
	</span>
</template>

<script>
import Button from "@/vue/common/Button";
import {mapActions} from "vuex";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

export default {

	components: {
		Button,
	},

	props: {
		jobId: {
			type: String,
			required: true,
		},
		jobProfileId: {
			type: String,
			required: true,
		},
		jobProfileName: {
			type: String,
			required: true,
		},
		initialInContacting: {
			type: Boolean,
			required: true,
		},
	},

	data ()
	{
		return {
			inContacting: this.initialInContacting,
		};
	},

	methods: {
		...mapActions('communication/contactJobProfile', {
			openFan: 'show'
		}),
		onClick ()
		{
			Event.push(
				new EventData()
					.setEvent(Event.APPLICANT_JOB)
					.setAction('Kontaktierung')
					.setName(this.jobProfileName)
			);

			this.openFan({
				jobId: this.jobId,
				jobProfileId: this.jobProfileId,
				jobProfileName: this.jobProfileName,
				onContacted: () =>
				{
					this.inContacting = true;

					this.$emit('contacted');
				}
			});
		},
	}
}
</script>
